export interface ConfigDTO {
  name: string;
  logo?: string;
  description?: string;
}

export class Config {
  private readonly _name: string;
  private readonly _logo?: string;
  private readonly _description?: string;

  static create(config: ConfigDTO): Config {
    return new Config(config);
  }

  constructor(config: ConfigDTO) {
    this._name = config.name;
    this._logo = config.logo;
    this._description = config.description;
  }

  public get name() {
    return this._name;
  }

  public get logoPath() {
    return `/image/${this._logo}`;
  }

  public get description() {
    return this._description;
  }
}
